import React, { createContext, useContext, useState } from 'react';
import { Select, SelectProps } from '@mui/material';
import { MobileMenuContext, MobileMenuPaper, useMobileMenu } from './ResponsiveMenu';

export const SelectLabelContext = createContext<React.ReactNode>(undefined);

/** Shared form select: anchored on desktop, a bottom action sheet on mobile. */
export default function ResponsiveSelect<T = unknown>({ sheetTitle, ...props }: SelectProps<T> & { sheetTitle?: React.ReactNode }) {
  const mobile = useMobileMenu();
  const fieldLabel = useContext(SelectLabelContext);
  const [open, setOpen] = useState(!!props.defaultOpen);
  const close = (event: React.SyntheticEvent) => {
    setOpen(false);
    props.onClose?.(event);
  };
  const menu = props.MenuProps;
  const title = sheetTitle || fieldLabel || props.label || props.inputProps?.['aria-label'] || props.SelectDisplayProps?.['aria-label'] || 'Choose an option';
  return <MobileMenuContext.Provider value={{ title, close }}>
    <Select<T> {...props} open={props.open ?? open}
      onOpen={event => { setOpen(true); props.onOpen?.(event); }} onClose={close}
      MenuProps={{ ...menu,
        anchorReference: mobile ? 'none' : menu?.anchorReference,
        slots: { ...menu?.slots, ...(mobile ? { paper: MobileMenuPaper } : {}) },
      }} />
  </MobileMenuContext.Provider>;
}
